/** Raíz de las rutas del Portal Condominio. */
export const RUTA_PORTAL_CONDOMINIO = "/admin/portal-condominio";

/** Detalle de una unidad por su cuenta de mantenimiento: la 419 tiene dos y el número no basta. */
export const rutaUnidadCondominio = (idCuenta: number): string =>
  `${RUTA_PORTAL_CONDOMINIO}/departamentos/${idCuenta}`;
